import React, { ReactNode } from 'react';

export const ShadowBarChartTitle = ({ children }: { children: ReactNode }) => {
    return (
        <div className="self-center text-lg font-medium leading-7 mb-3 text-dark dark:text-white">
            {children}
        </div>
    );
};
